export enum DigilockerRequestType {
  'personalAccountVerification' = 'personalAccountVerification',
  'documentUpload' = 'documentUpload',
}
